export default "__VITE_ASSET__CBYowzsL__"